import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section id="testimonials" class="section testimonials">
      <div class="container">
        <div class="section-header text-center">
          <h2 class="section-title">Témoignages</h2>
          <p class="section-subtitle">
            Découvrez ce que nos partenaires commerçants et clients disent de
            Zero-Waste.
          </p>
        </div>

        <div class="testimonial-tabs">
          <div class="tab-buttons">
            <button
              [class.active]="activeTab === 'merchants'"
              (click)="setActiveTab('merchants')"
            >
              Commerçants
            </button>
            <button
              [class.active]="activeTab === 'customers'"
              (click)="setActiveTab('customers')"
            >
              Clients
            </button>
          </div>

          <div
            class="testimonial-container"
            [class.merchants-active]="activeTab === 'merchants'"
            [class.customers-active]="activeTab === 'customers'"
          >
            <div class="testimonial-group merchants">
              <div
                class="testimonial-card"
                *ngFor="let testimonial of merchantTestimonials"
              >
                <div class="testimonial-content">
                  <div class="quote-icon">
                    <i class="fas fa-quote-left"></i>
                  </div>
                  <p>{{ testimonial.content }}</p>
                </div>
                <div class="testimonial-author">
                  <div class="author-image">
                    <img [src]="testimonial.image" [alt]="testimonial.name" />
                  </div>
                  <div class="author-info">
                    <h4>{{ testimonial.name }}</h4>
                    <p>{{ testimonial.business }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="testimonial-group customers">
              <div
                class="testimonial-card"
                *ngFor="let testimonial of customerTestimonials"
              >
                <div class="testimonial-content">
                  <div class="quote-icon">
                    <i class="fas fa-quote-left"></i>
                  </div>
                  <p>{{ testimonial.content }}</p>
                </div>
                <div class="testimonial-author">
                  <div class="author-image">
                    <img [src]="testimonial.image" [alt]="testimonial.name" />
                  </div>
                  <div class="author-info">
                    <h4>{{ testimonial.name }}</h4>
                    <p>{{ testimonial.location }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .testimonials {
        background-color: var(--light-color);
      }

      .testimonial-tabs {
        margin-top: 50px;
      }

      .tab-buttons {
        display: flex;
        justify-content: center;
        margin-bottom: 40px;
      }

      .tab-buttons button {
        background-color: transparent;
        border: none;
        padding: 12px 30px;
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--dark-gray);
        cursor: pointer;
        position: relative;
        transition: all 0.3s ease;
      }

      .tab-buttons button::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 3px;
        background-color: var(--primary-color);
        transition: width 0.3s ease;
      }

      .tab-buttons button.active {
        color: var(--primary-color);
      }

      .tab-buttons button.active::after {
        width: 80%;
      }

      .testimonial-container {
        position: relative;
        overflow: hidden;
        min-height: 400px;
      }

      .testimonial-group {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 30px;
        position: absolute;
        width: 100%;
        transition: transform 0.5s ease;
      }

      .merchants {
        transform: translateX(0);
      }

      .customers {
        transform: translateX(100%);
      }

      .testimonial-container.merchants-active .merchants {
        transform: translateX(0);
      }

      .testimonial-container.merchants-active .customers {
        transform: translateX(100%);
      }

      .testimonial-container.customers-active .merchants {
        transform: translateX(-100%);
      }

      .testimonial-container.customers-active .customers {
        transform: translateX(0);
      }

      .testimonial-card {
        background-color: var(--gray-color);
        border-radius: 15px;
        padding: 30px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
      }

      .testimonial-card:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      }

      .quote-icon {
        color: var(--primary-light);
        font-size: 2rem;
        margin-bottom: 15px;
      }

      .testimonial-content p {
        font-style: italic;
        color: var(--text-color);
        margin-bottom: 20px;
      }

      .testimonial-author {
        display: flex;
        align-items: center;
      }

      .author-image {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 15px;
      }

      .author-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .author-info h4 {
        font-size: 1.1rem;
        margin-bottom: 5px;
      }

      .author-info p {
        color: var(--dark-gray);
        font-size: 0.9rem;
      }

      @media (max-width: 992px) {
        .testimonial-group {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 768px) {
        .tab-buttons button {
          padding: 10px 20px;
          font-size: 1rem;
        }
      }
    `,
  ],
})
export class TestimonialsComponent {
  activeTab = 'merchants';

  merchantTestimonials = [
    {
      content:
        "Depuis que j'ai rejoint Zero-Waste, j'ai réduit mes pertes de 40% et j'ai attiré une nouvelle clientèle engagée. C'est une solution gagnant-gagnant pour mon commerce et pour la planète.",
      name: 'Sophie Martin',
      business: 'Boulangerie Les Délices',
      image: 'https://randomuser.me/api/portraits/women/65.jpg',
    },
    {
      content:
        "Zero-Waste m'a permis de valoriser mes invendus tout en sensibilisant mes clients à la lutte contre le gaspillage. Le processus est simple et l'équipe est très réactive.",
      name: 'Thomas Dubois',
      business: 'Primeur Bio & Local',
      image: 'https://randomuser.me/api/portraits/men/32.jpg',
    },
    {
      content:
        "Grâce à Zero-Waste, nous avons augmenté notre chiffre d'affaires de 15% et réduit nos déchets de manière significative. Une initiative que je recommande à tous les commerçants.",
      name: 'Marie Leroy',
      business: 'Restaurant Le Gourmand',
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
    },
    {
      content:
        'La plateforme est intuitive et nous permet de gérer facilement nos offres. Nos clients sont ravis de pouvoir faire une bonne action tout en faisant des économies.',
      name: 'Pierre Moreau',
      business: 'Supermarché Proximité',
      image: 'https://randomuser.me/api/portraits/men/22.jpg',
    },
  ];

  customerTestimonials = [
    {
      content:
        "Zero-Waste me permet de faire des économies tout en agissant pour l'environnement. Les produits sont de qualité et l'application est très facile à utiliser.",
      name: 'Julie Dupont',
      location: 'Paris',
      image: 'https://randomuser.me/api/portraits/women/29.jpg',
    },
    {
      content:
        "J'utilise Zero-Waste quotidiennement pour découvrir de nouveaux commerces près de chez moi. C'est une façon économique et écologique de faire ses courses.",
      name: 'Lucas Bernard',
      location: 'Lyon',
      image: 'https://randomuser.me/api/portraits/men/55.jpg',
    },
    {
      content:
        'Grâce à Zero-Waste, je réduis mon impact environnemental tout en découvrant des produits locaux de qualité. Une application indispensable au quotidien !',
      name: 'Emma Petit',
      location: 'Bordeaux',
      image: 'https://randomuser.me/api/portraits/women/12.jpg',
    },
    {
      content:
        'Zero-Waste a changé ma façon de consommer. Je fais des économies tout en luttant contre le gaspillage alimentaire. Je recommande vivement !',
      name: 'Nicolas Roux',
      location: 'Marseille',
      image: 'https://randomuser.me/api/portraits/men/67.jpg',
    },
  ];

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
